import { render } from "./ListsManage.vue?vue&type=template&id=c857a750&scoped=true"
import script from "./ListsManage.vue?vue&type=script&lang=ts"
export * from "./ListsManage.vue?vue&type=script&lang=ts"

import "./ListsManage.vue?vue&type=style&index=0&id=c857a750&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c857a750"

export default script